export default __webpack_public_path__ + "static/media/radio-selected-light.07e2747d.svg";